/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ChartOptions, ChartData } from 'chart.js';
import { ListResults } from 'model/reports/ListResults';
import _ from 'lodash';
import { ListChartData } from './base/ListChartData';
import {
  getWrappedHorizontalLabel,
  getReportColor,
  getPercentVal,
  getDataLablesConf,
} from 'reports/reports';

export const BarChartReport: React.FC<ListChartData> = ({
  report,
  instance,
}) => {
  let chart: Bar | null = null;
  useEffect(() => {
    if (instance && chart && chart.chartInstance) {
      instance(chart.chartInstance);
    }
  }, [chart, instance]);
  return (
    <Bar
      ref={ref => (chart = ref)}
      data={getChartData(report)}
      options={getChartOptions(report)}
      plugins={[ChartDataLabels]}
    />
  );
};

const getChartData = (report: ListResults): ChartData => ({
  labels: _.map(report.labels, l =>
    getWrappedHorizontalLabel(l, report.labels.length)
  ),
  datasets: [
    {
      label: 'Bar Chart Report',
      data: _.map(report.data, d => d.percent),
      backgroundColor: _.map(report.data, (_d, i) => getReportColor(i)),
    },
  ],
});

const getChartOptions = (report: ListResults): ChartOptions => ({
  legend: {
    display: false,
  },
  scales: {
    yAxes: [
      {
        ticks: {
          min: 0,
          max: 100,
          callback: function(value) {
            return getPercentVal(value);
          },
        },
        scaleLabel: {
          display: true,
          labelString: 'Percentage',
        },
      },
    ],
  },
  tooltips: {
    enabled: true,
    mode: 'single',
    displayColors: false,
    callbacks: {
      label: function(tooltipItems, _data) {
        if (
          tooltipItems.index !== undefined &&
          tooltipItems.index < report.data.length
        ) {
          const value = report.data[tooltipItems.index];
          const percent = getPercentVal(value.percent);
          const count = value.count;
          return [`${count} answers`, percent];
        }
        return '';
      },
    },
  },
  plugins: {
    datalabels: getDataLablesConf() as any,
  },
});
